// Edit each paragraph and its mobile summary together. HTML links/emphasis are supported.
export const about = {
  "id": "panel-6",
  "type": "story",
  "title": "About me",
  "blocks": [
    {
      "heading": "Who am I?",
      "desktop": "Hello, my name is Oliver! I'm an Associate Software Engineer at SIE, with a background in Computer Science at the University of Edinburgh. My journey spans over eight years of personal and academic experience in IT, from early robotics competitions to designing and building software systems. I'm a fast learner who enjoys collaborating with others, learning from fellow engineers and contributing to useful projects.",
      "mobile": "I'm Oliver, an <b>Associate Software Engineer at SIE</b>, with a Computer Science background from the University of Edinburgh. My interests span robotics, software systems and collaborative problem-solving."
    },
    {
      "heading": "What is this website?",
      "desktop": "This personal portfolio website was a personal project to reimagine site navigation through a fully interactive 3D solar system. Each planet acts as a portal to different sections of the portfolio. Built with Vite and Three.js, the project aims to showcase my web development skills, combined with a new area of technology for me in 3D modelling to create a visually engaging and unconventional user experience. The project showcases proficiency in JavaScript, modular design, event-driven interactions, and creative UI/UX thinking. I invite you to explore the GitHub repository for this project:<a href='https://github.com/popcorns41/solar-system-portfolio'target='_blank' rel='noopener noreferrer'>here</a>to browse this project's inspiration and current development stage.",
      "mobile": "Built with <b>Vite and Three.js</b>, this portfolio combines my web development skills with an interest in 3D experiences. Explore the <a href='https://github.com/popcorns41/solar-system-portfolio' target='_blank' rel='noopener noreferrer'>project on GitHub</a>."
    }
  ],
  "images": [
    {
      "src": "./info_images/stepHandShake.jpg",
      "alt": "About me Image 1",
      "caption": "Award ceremony for internship programme (further details see<a href='#panel-1'>here</a>)"
    },
    {
      "src": "./info_images/poolPalGroup.jpg",
      "alt": "About me Image 2",
      "caption": "Group photo during robotics fair (further details see <a href='#panel-3'>here</a>)"
    }
  ],
  "videos": []
};
